import { formatCellValueForExport } from "./formatters/index.js";
import { exportToCSV, generateExportFilename } from "./exportFunctions/index.js";

const exportInfluencerData = async ({
  allRows = [],
  filteredRows = [],
  selectedRows = [],
  visibleColumns,
  currentColumnPreset,
  exportType = "filtered",
  format = "csv",
  filters = [],
}) => {
  try {
    let dataToExport, columnsToExport;
    const hasSelectedRows = selectedRows && selectedRows.length > 0;
    
    if (exportType === "quick") {
      dataToExport = hasSelectedRows ? selectedRows : allRows;
      columnsToExport = ["id", "username", "public_email", "firstname", "assigned_member"];
    } else {
      dataToExport = hasSelectedRows ? selectedRows : filteredRows;
      columnsToExport = ["id", ...visibleColumns];
    }

    const filename = generateExportFilename({ exportType, filters, columnPreset: currentColumnPreset });

    if (format === "csv") {
      exportToCSV({
        rows: dataToExport, 
        columns: columnsToExport,
        filename, 
        formatCellValue: (value, columnName) => formatCellValueForExport({ value, columnName })
      });
    } else {
      throw new Error(`Unsupported export format: ${format}`);
    }

    return {
      success: true,
      message: `Exported ${dataToExport.length} rows to ${format.toUpperCase()}`,
      filename: `${filename}.${format}`,
    };
  } catch (error) {
    console.error("Export failed:", error);
    throw error;
  }
};

export default exportInfluencerData;
